/**
 * 审批动作定义
 */

export class WorkitemAction {

    /**
     * 动作编号
     */
    code: string;

    /**
     * 动作显示名称
     */
    name: string;

    /**
     * 是否主要操作
     */
    isPrimaryAction: boolean;

    /**
     * 审批动作参数
     */
    parameters: any;
}
